export const transformTruecallerStatus = (truecallerData: any) => {
  const { status, response = {} } = truecallerData;
  const { state, action, user_response: userResponse = {} } = response;
  const {
    success: useResponseSuccess,
    status: userStatus,
    error: errorCode,
    message,
  } = userResponse;
  const updatedUserData = {};
  const transformData = {
    status,
    state,
    action,
    useResponseSuccess,
    updatedUserData,
    errorCode,
    message,
    userStatus,
  };
  return transformData;
};
